// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "google_review".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "google_review" table (1:1 with a DB row, on the wire). */
export const googleReviewAtomSchema = z.object({
    id: z.string(),
    googleMyBusinessAccountId: z.string(),
    reviewId: z.string(),
    reviewerName: z.string(),
    reviewerPhotoUrl: z.string().nullable(),
    rating: z.number(),
    comment: z.string().nullable(),
    replyComment: z.string().nullable(),
    repliedAt: z.string().datetime().nullable(),
    publishedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=googleReview.js.map